import { FC } from 'react';
import { UserGroupIcon } from '../../../lib/icons';

export interface GroupCountCellProps {
  count?: number | undefined;
}

export const GroupCountCell: FC<GroupCountCellProps> = ({ count }) => {
  return (
    <div className="flex gap-0.5">
      {count}
      <UserGroupIcon width={20} />
    </div>
  );
};
